import clsx from 'clsx';
import { getFallbackImg } from '../../utils/OfferUtils';
import config from '../../lib/config';
import {
  CLASSIC_ASPECT_RATIO,
  EXPLORE_THIS_OFFER,
  MPO_SBO_BUTTON,
  SINGLE_BRAND_MULTI_PROP_OFFER,
  SQUARE_ASPECT_RATIO,
  WIDE_ASPECT_RATIO,
} from '../../constants/OffersHeroConstants';

import { Text, Types, Image, Button, Heading, LogoContainer } from '@marriott/mi-ui-library';
import { OffersHeroMultiPropertyProps } from './OffersHero.types';
import { OffersHeroMultiPropertyStyled } from './OffersHero.styles';
import { useRef } from 'react';
import { IMAGE_CACHE_DOMAIN, IMAGE_CACHE_DOMAIN_CN, INTERNAL_CTA_TYPE } from '../../constants/CommonConstants';
import { useClientEnvVarsStore } from '@marriott/mi-store-utils';

export const OffersHeroMultiProperty: React.FC<OffersHeroMultiPropertyProps> = props => {
  const { variation, offersHeroProps, modelObj, getOfferDataFromLightning, isLogoFlagEnabled } = props;
  const offerObj = getOfferDataFromLightning
    ? offersHeroProps?.responseObject?.offers?.[0]
    : offersHeroProps?.responseObject?.edges?.[0]?.node;
  const { envVarsObject } = useClientEnvVarsStore();
  const imageDomain = envVarsObject?.['UXL_IMAGE_CACHE_DOMAIN'] ?? IMAGE_CACHE_DOMAIN;
  const BAIDU_MAP_API_KEY = envVarsObject?.['BAIDU_MAP_API_KEY'];
  console.log(`inside OffersHeroMultiProperty BAIDU_MAP_API_KEY:, ${BAIDU_MAP_API_KEY}`); // eslint-disable-line no-console
  const isChinaDomain = imageDomain === IMAGE_CACHE_DOMAIN_CN;
  let desktopImageSrc = '';
  const fallBackImg = getFallbackImg(
    isChinaDomain ? config.FALLBACK_CN_IMG_URI : config.FALLBACK_IMG_URI,
    CLASSIC_ASPECT_RATIO
  );
  const bannerTextClassName = clsx('t-font-swiss721');
  const OffersHeroMPORef = useRef(null);
  const ASPECT_RATIO_UXL_FIELD_MAPPING = {
    CLASSIC: 'classicHorizontal',
  };
  const objKey = CLASSIC_ASPECT_RATIO as keyof typeof ASPECT_RATIO_UXL_FIELD_MAPPING;
  const imageUrls = offerObj?.media?.primaryImage?.imageUrls;
  const DACImagePath = imageUrls?.[ASPECT_RATIO_UXL_FIELD_MAPPING?.[objKey]];
  if (DACImagePath) {
    desktopImageSrc = imageDomain + DACImagePath;
  } else {
    desktopImageSrc = imageDomain + fallBackImg;
  }
  const handleExploreOffer = (): void => {
    const targetSection = document.getElementById('offers-search-form')?.offsetTop;
    const isFixedHeader = document.body.classList.contains('fixed-header');
    window.scrollTo({
      top: targetSection ? (isFixedHeader ? targetSection - 50 : targetSection - 150) : 0,
      behavior: 'smooth',
    });
  };

  return (
    <OffersHeroMultiPropertyStyled className="brand-css">
      <div
        className={`section-wrapper ${
          variation === SINGLE_BRAND_MULTI_PROP_OFFER ? modelObj?.styleclass ?? `color-scheme7` : ''
        }`}
      >
        <div className="image-section">
          <Image
            title={`${offerObj?.title} img`}
            customClass="hero-img"
            defaultImageURL={desktopImageSrc}
            altText={`${offerObj?.title} img`}
            loading="eager"
          ></Image>
        </div>
        <div
          className={`details-section ${
            variation === SINGLE_BRAND_MULTI_PROP_OFFER && 't-background-color-rgba'
          } ${variation}`}
        >
          <div className="details mpo">
            {variation === SINGLE_BRAND_MULTI_PROP_OFFER &&
              (isLogoFlagEnabled ? (
                <LogoContainer
                  brand={`brand-logo-${offersHeroProps?.brand}`}
                  width={160}
                  height={90}
                  aspectRatio="3:2"
                  alignment="Centered"
                  isLink={false}
                  color={'background-aware'}
                />
              ) : (
                <div className="logo t-brand-logo-s">
                  <div
                    className={`brand-image brand-logo-${offersHeroProps?.brand} hotel-brand-logo t-brand-logo`}
                  ></div>
                </div>
              ))}
            <div className="title">
              <Heading titleText={offerObj?.title} variation={Types.headingType.title} fontSize={Types.size.medium} />
            </div>
            <div className="desc">
              <Text
                copyText={offerObj?.descriptionTeaser}
                fontSize={Types.size.medium}
                customClass={clsx('t-font-swiss721')}
                element={Types.tags.paragraph}
              />
            </div>
            <div className={`navigation-btns ${variation === SINGLE_BRAND_MULTI_PROP_OFFER ? MPO_SBO_BUTTON : ''}`}>
              <Button
                callback={(): void => handleExploreOffer()}
                custom_click_track_value={`${modelObj?.id}|${modelObj?.exploreThisOffer}|${INTERNAL_CTA_TYPE}`}
                className={clsx(`m-button-primary  ${bannerTextClassName}`)}
                trackingProperties={modelObj?.trackingProperties}
                ref={OffersHeroMPORef}
              >
                {modelObj?.exploreThisOffer ? modelObj.exploreThisOffer : EXPLORE_THIS_OFFER}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </OffersHeroMultiPropertyStyled>
  );
};

export default OffersHeroMultiProperty;
